import { render, staticRenderFns } from "./CakeshopAddressDetail.vue?vue&type=template&id=f4ab0244&scoped=true&"
import script from "./CakeshopAddressDetail.vue?vue&type=script&lang=js&"
export * from "./CakeshopAddressDetail.vue?vue&type=script&lang=js&"
import style0 from "./CakeshopAddressDetail.vue?vue&type=style&index=0&id=f4ab0244&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ab0244",
  null
  
)

export default component.exports